import React from 'react';
import PropTypes from 'prop-types';
import { LeftNavigationBar, DashboardNavigationLink } from '@unite-us/app-components';
import { withRouter } from 'react-router';
import { useCurrentPayerId } from 'common/contexts/CurrentProviderContext';
import { ENROLLMENT_STATUSES } from '../constants';
import { useEnrollmentStatusCount } from '../hooks/useEnrollmentStatusCount';

export const StatusSelectBar = ({ router }) => {
  const payerId = useCurrentPayerId();
  const openCount = useEnrollmentStatusCount(ENROLLMENT_STATUSES.open, payerId);
  return (
    <LeftNavigationBar className="space-y-4 -mb-20">
      <DashboardNavigationLink
        className="text-base"
        label="Open"
        count={openCount || undefined}
        to="/enrollments/open"
        data-testid="open-enrollments-link"
        isActive={router && router.isActive({ pathname: '/enrollments/open' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="Accepted"
        to="/enrollments/accepted"
        isActive={router && router.isActive({ pathname: '/enrollments/accepted' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="Rejected"
        to="/enrollments/rejected"
        isActive={router && router.isActive({ pathname: '/enrollments/rejected' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="Canceled"
        to="/enrollments/canceled"
        isActive={router && router.isActive({ pathname: '/enrollments/canceled' })}
      />
      <DashboardNavigationLink
        className="text-base"
        label="All Requests"
        to="/enrollments/all"
        isActive={router && router.isActive({ pathname: '/enrollments/all' })}
      />
    </LeftNavigationBar>
  );
};

StatusSelectBar.propTypes = {
  router: PropTypes.shape({
    isActive: PropTypes.func,
  }).isRequired,
};

export default withRouter(StatusSelectBar);
